module.exports = __webpack_public_path__ + "static/media/copylink-white.06d56f9d.svg";